import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

const { div, p } = hh(h);
import R from 'ramda';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { v4 } from 'uuid';
import Form from 'react-jsonschema-form';
import FieldTemplate from '../ApplicationForm/FieldTemplate';
import Submit from '../Submit';
import schemaBuilder, { baseQuestions, baseUiSchema, baseWidgets } from '../ApplicationForm/schema-builder';
import { customUiSchema, widgets, jsonSchema } from './schema';
import { browserHistory } from 'react-router';
import classNames from 'classnames';
import styles from './missing-course.css';

const MissingCourse = ({mutate}) => {
    const { defaultSchema, defaultUiSchema } = schemaBuilder(R.merge(baseQuestions, R.prop('properties', jsonSchema)),
baseUiSchema, []);
    const uiSchema = R.merge(defaultUiSchema, customUiSchema);

    const onSubmit = ({formData: { firstName, lastName, email, secondaryEmail, ...rest}}) => {
        const question = (field) => R.path(['properties', field, 'title'], defaultSchema);
        const answer = (field) => R.prop(field, rest);

        const answers = R.reduce(
            (answers, field) => R.assoc(field, {question: question(field), answer: answer(field)}, answers),
            {},
            R.keys(rest)
        );

        mutate({
            variables: {
                clientMutationId: v4(),
                firstName,
                lastName,
                email,
                answers
            }
        })
        .then(() => {
            browserHistory.push('/contact/success');
        });
    };


    return (
        div({className: styles.notFoundContainer}, [
            p({className: styles.notFoundTextMain}, 'Can’t find your uni? Sorry!'),
            p({className: styles.notFoundTextSub}, 'Register your interest and we’ll get to you as soon as we can.'),
            h(Form, {
                className: classNames(styles.notFoundForm),
                schema: defaultSchema,
                FieldTemplate,
                widgets: R.merge(baseWidgets, widgets),
                uiSchema,
                // onChange: log('changed'),
                // onError: log('errors'),
                onSubmit
            }, [
                div({className: styles.submitContainer}, [
                    h(Submit)
                ])
            ])
        ])
    );
};

export default graphql(gql`
  mutation submitInterest( $clientMutationId: String!, $firstName: String!, $lastName: String!, $email: String!, $answers: JSON!) {
        submitInterest(input: {
            clientMutationId: $clientMutationId,
            form: {
                firstName: $firstName,
                lastName: $lastName,
                email: $email,
                answers: $answers
            }
        }) {
            clientMutationId
            newUser {
                id,
                email
            }
        }
    }
    `)(MissingCourse);



/** WEBPACK FOOTER **
 ** ./src/MissingCourse/index.js
 **/